import styled from 'styled-components';
import tw from 'tailwind.macro';
import { math } from 'polished';

export const LgTitle = styled.h1`
  ${tw`font-display text-3xl text-black`};
  ${props =>
    (props.color === 'black' && tw`text-black`) ||
    (props.color === 'green' && tw`text-green`) ||
    (props.color === 'pink' && tw`text-pink`) ||
    (props.color === 'white' && tw`text-white`)}
  ${props =>
    (props.marginBottom === '0' && tw`mb-0`) ||
    (props.marginBottom === '6' && tw`mb-6`) ||
    (props.marginBottom === '8' && tw`mb-8`) ||
    (props.marginBottom === '10' && tw`mb-10`) ||
    (props.marginBottom === '12' && tw`mb-12`) ||
    (props.marginBottom === '14' && tw`mb-14`) ||
    (props.marginBottom === '16' && tw`mb-16`) ||
    (props.marginBottom === '20' && tw`mb-20`) ||
    (props.marginBottom === '24' && tw`mb-24`) ||
    (props.marginBottom === '30' && tw`mb-30`) ||
    (props.marginBottom === '32' && tw`mb-32`) ||
    (props.marginBottom === '36' && tw`mb-36`) ||
    (props.marginBottom === '38' && tw`mb-38`) ||
    (props.marginBottom === '44' && tw`mb-44`) ||
    (props.marginBottom === '48' && tw`mb-48`) ||
    (props.marginBottom === '64' && tw`mb-64`) ||
    (props.marginBottom === '144' && tw`mb-144`)}
  line-height: ${math('56/44')};
`;

export const BaseTitle = styled.h2`
  ${tw`font-bold font-display text-2xl text-black`};
  ${props =>
    (props.color === 'black' && tw`text-black`) ||
    (props.color === 'green' && tw`text-green`) ||
    (props.color === 'purple' && tw`text-purple`) ||
    (props.color === 'white' && tw`text-white`)}
  ${props =>
    (props.marginBottom === '0' && tw`mb-0`) ||
    (props.marginBottom === '6' && tw`mb-6`) ||
    (props.marginBottom === '8' && tw`mb-8`) ||
    (props.marginBottom === '10' && tw`mb-10`) ||
    (props.marginBottom === '12' && tw`mb-12`) ||
    (props.marginBottom === '14' && tw`mb-14`) ||
    (props.marginBottom === '16' && tw`mb-16`) ||
    (props.marginBottom === '20' && tw`mb-20`) ||
    (props.marginBottom === '24' && tw`mb-24`) ||
    (props.marginBottom === '30' && tw`mb-30`) ||
    (props.marginBottom === '32' && tw`mb-32`) ||
    (props.marginBottom === '36' && tw`mb-36`) ||
    (props.marginBottom === '38' && tw`mb-38`) ||
    (props.marginBottom === '44' && tw`mb-44`) ||
    (props.marginBottom === '48' && tw`mb-48`) ||
    (props.marginBottom === '64' && tw`mb-64`) ||
    (props.marginBottom === '144' && tw`mb-144`)}
  line-height: ${math('36/32')};
`;

export const SmTitle = styled.h3`
  ${tw`font-bold font-display text-xl text-black`};
  ${props =>
    (props.color === 'black' && tw`text-black`) ||
    (props.color === 'green' && tw`text-green`) ||
    (props.color === 'pink' && tw`text-pink`) ||
    (props.color === 'white' && tw`text-white`)}
  ${props =>
    (props.marginBottom === '0' && tw`mb-0`) ||
    (props.marginBottom === '6' && tw`mb-6`) ||
    (props.marginBottom === '8' && tw`mb-8`) ||
    (props.marginBottom === '10' && tw`mb-10`) ||
    (props.marginBottom === '12' && tw`mb-12`) ||
    (props.marginBottom === '14' && tw`mb-14`) ||
    (props.marginBottom === '16' && tw`mb-16`) ||
    (props.marginBottom === '20' && tw`mb-20`) ||
    (props.marginBottom === '24' && tw`mb-24`) ||
    (props.marginBottom === '30' && tw`mb-30`) ||
    (props.marginBottom === '32' && tw`mb-32`) ||
    (props.marginBottom === '36' && tw`mb-36`) ||
    (props.marginBottom === '38' && tw`mb-38`) ||
    (props.marginBottom === '44' && tw`mb-44`) ||
    (props.marginBottom === '48' && tw`mb-48`) ||
    (props.marginBottom === '64' && tw`mb-64`) ||
    (props.marginBottom === '144' && tw`mb-144`)}
  line-height: ${math('28/24')};
`;

export const XsTitle = styled.h4`
  ${tw`font-bold font-display text-lg text-black`};
  ${props =>
    (props.color === 'black' && tw`text-black`) ||
    (props.color === 'green' && tw`text-green`) ||
    (props.color === 'pink' && tw`text-pink`) ||
    (props.color === 'purple' && tw`text-purple`)}
  ${props =>
    (props.marginBottom === '0' && tw`mb-0`) ||
    (props.marginBottom === '6' && tw`mb-6`) ||
    (props.marginBottom === '8' && tw`mb-8`) ||
    (props.marginBottom === '10' && tw`mb-10`) ||
    (props.marginBottom === '12' && tw`mb-12`) ||
    (props.marginBottom === '14' && tw`mb-14`) ||
    (props.marginBottom === '16' && tw`mb-16`) ||
    (props.marginBottom === '20' && tw`mb-20`) ||
    (props.marginBottom === '24' && tw`mb-24`) ||
    (props.marginBottom === '30' && tw`mb-30`) ||
    (props.marginBottom === '32' && tw`mb-32`) ||
    (props.marginBottom === '36' && tw`mb-36`) ||
    (props.marginBottom === '38' && tw`mb-38`) ||
    (props.marginBottom === '44' && tw`mb-44`) ||
    (props.marginBottom === '48' && tw`mb-48`) ||
    (props.marginBottom === '64' && tw`mb-64`) ||
    (props.marginBottom === '144' && tw`mb-144`)}
  line-height: ${math('24/19')};
`;
